const INVALID_PASSCODE = 'Invalid passcode. Please try again.';
const FAILED_TO_DOWNLOAD = 'Failed to download file. Please try again.';
const FAILED_PRESIGNED_URL =
  'Failed to retrieve presigned URL. Please try again.';
const VALIDATED_TITLE_TEXT = 'Passcode Validated';
const VALIDATED_SUBTITLE_TEXT =
  'Your download will begin automatically.' +
  ' If it doesn\'t, click the file to manually start the download.';
const DOWNLOAD_TITLE_TEXT = 'Download File';
const DOWNLOAD_SUBTITLE_TEXT =
  'Please enter the passcode from the email to access your file';
const ERROR_MESSAGE =
  'The passcode you entered is incorrect, or the file could not be located. Please check the passcode and try again.';
const DOCUMENT_DOWNLOAD_ROUTE = '/signedUrl';
const SERVER_GET_PRESIGNED_ENDPOINT = '/getPresignedUrl';
const UNAUTHORIZED_STATUS_CODE = 401;
const FILE_NAME_CHAR_LIMIT = 10;
const PASSCODE_REGEX = /^[a-zA-Z0-9]{5,32}$/;

export {
  INVALID_PASSCODE,
  FAILED_TO_DOWNLOAD,
  UNAUTHORIZED_STATUS_CODE,
  FILE_NAME_CHAR_LIMIT,
  FAILED_PRESIGNED_URL,
  DOCUMENT_DOWNLOAD_ROUTE,
  SERVER_GET_PRESIGNED_ENDPOINT,
  VALIDATED_TITLE_TEXT,
  VALIDATED_SUBTITLE_TEXT,
  DOWNLOAD_TITLE_TEXT,
  DOWNLOAD_SUBTITLE_TEXT,
  PASSCODE_REGEX,
  ERROR_MESSAGE
};
